import React from "react";
import { InventoryControlPanel } from "./InventoryControlPanel";
import { UnifiedReturnsTable } from "./UnifiedReturnsTable";
import { DamagedItemsTable } from "./DamagedItemsTable";
import { DamagedItemDetailModal } from "./DamagedItemDetailModal";
import { InventoryStats } from "./InventoryStats";
import { Tabs } from "../../../components/ui";
//updated Halimunnisa 2026-06-8
//Implemented a comprehensive export functionality for returns that allows users to easily export their return data to Excel. The export includes robust data mapping and formatting to ensure that the exported file is well-structured and user-friendly, making it easier for users to analyze and share their return information outside of the application. The export process also includes error handling and user feedback to enhance the overall experience when exporting return records.
import { toast } from "react-hot-toast";
import { RETURNS_SUB_TABS } from "../../../constants/globalConstants";

export const ReturnsView = ({
  returnsSubTab,
  setReturnsSubTab,
  search,
  setSearch,
  filters,
  setFilters,
  dynamicSettings,
  activeTab,
  activeReturnFilterOptions,
  consolidatedReturns,
  damagedItems,
  setSelReturn,
  setSelPR,
  setSelSR,
  setPurchaseReturnOpen,
  setSaleReturnOpen,
  handleConfirmReturn,
  setRestockReturn,
  setViewPaymentData,
  setSelectedPRForPayment,
  setSelectedSRForPayment,
}) => {
  const [selDamagedItem, setSelDamagedItem] = React.useState(null);
  // Excel Export

  //updated Halimunnisa 2026-06-08
  //Implemented a comprehensive export functionality for returns that allows users to easily export their return data to Excel. The export includes robust data mapping and formatting to ensure that the exported file is well-structured and user-friendly, making it easier for users to analyze and share their return information outside of the application. The export process also includes error handling and user feedback to enhance the overall experience when exporting return records.
  const [isExporting, setIsExporting] = React.useState(false);

  const handleExportMasterReturns = async () => {
    if (isExporting) return;
    try {
      setIsExporting(true);
      if (!consolidatedReturns || consolidatedReturns.length === 0) {
        toast.error("No return records to export");
        return;
      }

      const { exportToExcel } = await import("../../../utils/exportUtils");
      const exportData = consolidatedReturns.map(r => ({
        'Master Returns': r.rawType === 'sale' ? r.invoiceNo : r.returnId,
        'Return Type': r.returnType === 'Purchase' || r.returnType === 'Purchase Return' ? 'Purchase Return' : (r.rawType === 'sale' ? 'Sale Return' : 'Site Return'),
        'Status': (r.status || 'pending').toUpperCase(),
        'Reason': r.reason || r.remarks || r.description || "General Return",
        'Party Name': r.party || "—",
        'Party Type': r.rawType === 'purchase' ? 'Vendor' : (r.rawType === 'sale' ? 'Customer' : 'Project Site'),
        'Source (Store)': typeof r.store === 'object' ? (r.store?.storeName || r.store?.name) : (r.store || 'Unknown Store'),
        'Category': typeof r.category === 'object' ? (r.category?.title || r.category?.name || r.category?.categoryName) : (r.category || '—'),
        'Items': r.itemSummary || '—',
        'Total Quantity': r.itemQuantity || 0,
        'Total Value': r.amount || 0,
        'Refunded Amount': r.receivedAmount || 0,
        'Balance Due': (Number(r.amount || 0) - Number(r.receivedAmount || 0)) || 0,
        'Date': r.date ? new Date(r.date).toLocaleDateString('en-IN') : "—"
      }));

      await exportToExcel(exportData, `Master_Returns_Export_${new Date().toISOString().split('T')[0]}`);
      toast.success("Master Returns exported successfully");
    } catch (error) {
      console.error("Export failed:", error);
      toast.error("Failed to export returns");
    } finally {
      setIsExporting(false);
    }
  };

  const handleExportPurchaseReturns = async () => {
    if (isExporting) return;
    try {
      setIsExporting(true);
      const prData = consolidatedReturns.filter(r => r.rawType === "purchase" || r.returnType === "Purchase");
      if (!prData || prData.length === 0) {
        toast.error("No purchase return records to export");
        return;
      }

      const { exportToExcel } = await import("../../../utils/exportUtils");
      const exportData = prData.map(r => ({
        'Purchase Return No': r.returnNo || `PR-${(r._id || r.originalData?._id || '').toString().slice(-6).toUpperCase()}`,
        'Invoice #': r.invoiceNo || r.returnId || '—',
        'Status': (r.status || 'pending').toUpperCase(),
        'Reason': r.reason || r.remarks || r.description || "—",
        'Vendor': r.party || "—",
        'Store': typeof r.store === 'object' ? (r.store?.storeName || r.store?.name) : (r.store || 'Unknown Store'),
        'Category': typeof r.category === 'object' ? (r.category?.title || r.category?.name || r.category?.categoryName) : (r.category || '—'),
        'Items': r.itemSummary || '—',
        'Total Quantity': r.itemQuantity || 0,
        'Total Value': r.amount || 0,
        'Refunded Amount': r.receivedAmount || 0,
        'Balance Due': (Number(r.amount || 0) - Number(r.receivedAmount || 0)) || 0,
        'Date': r.date ? new Date(r.date).toLocaleDateString('en-IN') : "—"
      }));

      await exportToExcel(exportData, `Purchase_Returns_Export_${new Date().toISOString().split('T')[0]}`);
      toast.success("Purchase Returns exported successfully");
    } catch (error) {
      console.error("Export failed:", error);
      toast.error("Failed to export purchase returns");
    } finally {
      setIsExporting(false);
    }
  };

  const handleExportSaleReturns = async () => {
    if (isExporting) return;
    try {
      setIsExporting(true);
      const srData = consolidatedReturns.filter(r => r.rawType === "sale" || r.returnType === "SALE");
      if (!srData || srData.length === 0) {
        toast.error("No sale return records to export");
        return;
      }

      const { exportToExcel } = await import("../../../utils/exportUtils");
      const exportData = srData.map(r => ({
        'Sale Return No': r.returnNo || `SR-${(r._id || r.originalData?._id || '').toString().slice(-6).toUpperCase()}`,
        'Invoice #': r.invoiceNo || r.returnId || '—',
        'Status': (r.status || 'pending').toUpperCase(),
        'Reason': r.reason || r.remarks || r.description || "—",
        'Customer': r.party || "—",
        'Store': typeof r.store === 'object' ? (r.store?.storeName || r.store?.name) : (r.store || 'Unknown Store'),
        'Category': typeof r.category === 'object' ? (r.category?.title || r.category?.name || r.category?.categoryName) : (r.category || '—'),
        'Items': r.itemSummary || '—',
        'Total Quantity': r.itemQuantity || 0,
        'Total Value': r.amount || 0,
        'Refunded Amount': r.receivedAmount || 0,
        'Balance Due': (Number(r.amount || 0) - Number(r.receivedAmount || 0)) || 0,
        'Date': r.date ? new Date(r.date).toLocaleDateString('en-IN') : "—"
      }));

      await exportToExcel(exportData, `Sale_Returns_Export_${new Date().toISOString().split('T')[0]}`);
      toast.success("Sale Returns exported successfully");
    } catch (error) {
      console.error("Export failed:", error);
      toast.error("Failed to export sale returns");
    } finally {
      setIsExporting(false);
    }
  };

  const handleExportDamagedItems = async () => {
    if (isExporting) return;
    try {
      setIsExporting(true);
      if (!damagedItems || damagedItems.length === 0) {
        toast.error("No damaged items records to export");
        return;
      }

      const { exportToExcel } = await import("../../../utils/exportUtils");
      const exportData = damagedItems.map(r => {
        let value = r.totalDamagedValue || 0;
        if (value === 0 && r.damagedItems) {
            value = r.damagedItems.reduce((acc, curr) => acc + ((curr.damagedQty || 0) * (curr.rate || 0)), 0);
        }
        
        const itemsList = (r.damagedItems || []).map(item => {
            const qty = item.damagedQty || 0;
            const rate = item.rate || 0;
            const amount = qty * rate;
            const itemName = item.item?.name || item.itemName || "Unknown Item";
            const reason = item.reason ? `[Reason: ${item.reason}] ` : '';
            return `${qty}x ${itemName} ${reason}(Value: ${amount})`;
        }).join(' | ');

        const partyStr = r.returnRef?.vendor?.name || r.returnRef?.vendor?.vendorName || r.returnRef?.supplier?.name || r.returnRef?.party || r.returnRef?.customer?.name || r.returnRef?.project?.customerName || "—";

        return {
          'Invoice / Return Ref': r.returnRef?.invoiceNo || r.returnRef?.originalInvoiceNo || r.invoice || "N/A",
          'Source Type': r.type || "UNKNOWN",
          'Party': partyStr,
          'Date': r.date ? new Date(r.date).toLocaleDateString('en-IN') : "N/A",
          'Damaged Items (Qty, Name, Reason, Value)': itemsList || '—',
          'Total Items': r.totalDamagedQty || 0,
          'Total Value': value
        };
      });

      await exportToExcel(exportData, `Damaged_Items_Export_${new Date().toISOString().split('T')[0]}`);
      toast.success("Damaged Items exported successfully");
    } catch (error) {
      console.error("Export failed:", error);
      toast.error("Failed to export damaged items");
    } finally {
      setIsExporting(false);
    }
  };

  const renderReturnsContent = () => {
    switch (returnsSubTab) {
      case RETURNS_SUB_TABS.MASTER:
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <InventoryControlPanel
              activeTab={activeTab}
              search={search}
              setSearch={setSearch}
              filters={filters}
              setFilters={setFilters}
              dynamicSettings={dynamicSettings}
              categories={activeReturnFilterOptions?.categories}
              parties={activeReturnFilterOptions?.parties}
              partyLabel="Parties"
              showStatusFilter={false}
              //updated Halimunnisa 2026-06-08
              //Implemented a comprehensive export functionality for returns that allows users to easily export their return data to Excel. The export includes robust data mapping and formatting to ensure that the exported file is well-structured and user-friendly, making it easier for users to analyze and share their return information outside of the application. The export process also includes error handling and user feedback to enhance the overall experience when exporting return records.
              onExport={handleExportMasterReturns}
              isExporting={isExporting}
            />
            <div className="flex items-center justify-between mb-4 px-2">
              <h2 className="text-[11px] font-black uppercase tracking-widest text-slate-500">
                Master Returns
              </h2>
              <p className="text-xs text-brand-blue font-medium bg-blue-50 px-3 py-1 rounded-full border border-blue-100 shadow-sm">
                All Inward Flow (Site, Purchase, Sale)
              </p>
            </div>
            <UnifiedReturnsTable
              returns={consolidatedReturns}
              subTab={returnsSubTab}
              onView={(r) => {
                const type = r.rawType || r.returnType?.toLowerCase();
                if (type === "site") setSelReturn(r.originalData || r);
                else if (type === "purchase") setSelPR(r.originalData || r);
                else if (type === "sale") setSelSR(r.originalData || r);
              }}
              onEdit={(r) => {
                const type = r.rawType || r.returnType?.toLowerCase();
                if (type === "purchase") {
                  setSelPR(r.originalData || r);
                  setPurchaseReturnOpen(true);
                } else if (type === "sale") {
                  setSelSR(r.originalData || r);
                  setSaleReturnOpen(true);
                }
              }}
              onRestock={(r) => setRestockReturn(r)}
              onConfirm={(item, action) => handleConfirmReturn(item, action)}
              onViewPayment={(r) =>
                setSelectedPRForPayment(r.originalData || r)
              }
              onGoToTab={setReturnsSubTab}
            />
          </div>
        );
      case RETURNS_SUB_TABS.SITE:
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <InventoryControlPanel
              activeTab={activeTab}
              search={search}
              setSearch={setSearch}
              filters={filters}
              setFilters={setFilters}
              dynamicSettings={dynamicSettings}
              onAddItemClick={() => {
                setSelSR(null);
                setSaleReturnOpen(true);
              }}
              buttonLabel="Return"
              categories={activeReturnFilterOptions?.categories}
              parties={activeReturnFilterOptions?.parties}
              partyLabel="Parties"
              showStatusFilter={false}
            />
            <div className="flex items-center justify-between mb-4 px-2">
              <h2 className="text-[11px] font-black uppercase tracking-widest text-slate-500">
                Site Returns
              </h2>
              <p className="text-xs text-orange-500 font-medium bg-orange-50 px-3 py-1 rounded-full border border-orange-100 shadow-sm">
                Unused Material Returning to Store
              </p>
            </div>
            <UnifiedReturnsTable
              returns={consolidatedReturns.filter(
                (r) => r.rawType === "site" || r.returnType === "Site",
              )}
              subTab={returnsSubTab}
              onView={(r) => setSelReturn(r.originalData || r)}
              onRestock={(r) => setRestockReturn(r)}
              onConfirm={(item, action) => handleConfirmReturn(item, action)}
              onViewPayment={(r) =>
                setSelectedPRForPayment(r.originalData || r)
              }
              onGoToTab={setReturnsSubTab}
            />
          </div>
        );
      case RETURNS_SUB_TABS.SALES:
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <InventoryControlPanel
              activeTab={activeTab}
              search={search}
              setSearch={setSearch}
              filters={filters}
              setFilters={setFilters}
              dynamicSettings={dynamicSettings}
              onAddItemClick={() => {
                setSelSR(null);
                setSaleReturnOpen(true);
              }}
              buttonLabel="Return"
              categories={activeReturnFilterOptions?.categories}
              parties={activeReturnFilterOptions?.parties}
              partyLabel="Parties"
              showStatusFilter={false}
              onExport={handleExportSaleReturns}
              isExporting={isExporting}
            />
            <div className="flex items-center justify-between mb-4 px-2">
              <h2 className="text-[11px] font-black uppercase tracking-widest text-slate-500">
                Sale Returns
              </h2>
            </div>
            <UnifiedReturnsTable
              returns={consolidatedReturns.filter(
                (r) => r.rawType === "sale" || r.returnType === "SALE",
              )}
              subTab={returnsSubTab}
              onView={(r) => setSelSR(r.originalData || r)}
              onViewPayment={(r) => setSelectedSRForPayment(r.originalData || r)}
              onRestock={(r) => setRestockReturn(r)}
              onConfirm={(item, action) => handleConfirmReturn(item, action)}
              onGoToTab={setReturnsSubTab}
            />
          </div>
        );
      case RETURNS_SUB_TABS.PURCHASES:
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <InventoryControlPanel
              activeTab={activeTab}
              search={search}
              setSearch={setSearch}
              filters={filters}
              setFilters={setFilters}
              dynamicSettings={dynamicSettings}
              onAddItemClick={() => {
                setSelPR(null);
                setPurchaseReturnOpen(true);
              }}
              buttonLabel="Return"
              categories={activeReturnFilterOptions?.categories}
              parties={activeReturnFilterOptions?.parties}
              partyLabel="Parties"
              showStatusFilter={false}
              onExport={handleExportPurchaseReturns}
              isExporting={isExporting}
            />
            <div className="flex items-center justify-between mb-4 px-2">
              <h2 className="text-[11px] font-black uppercase tracking-widest text-slate-500">
                Purchase Returns
              </h2>
            </div>
            <UnifiedReturnsTable
              returns={consolidatedReturns.filter(
                (r) => r.rawType === "purchase" || r.returnType === "Purchase",
              )}
              subTab={returnsSubTab}
              onView={(r) => setSelPR(r.originalData || r)}
              onEdit={(r) => {
                setSelPR(r.originalData || r);
                setPurchaseReturnOpen(true);
              }}
              onRestock={(r) => setRestockReturn(r)}
              onConfirm={(item, action) => handleConfirmReturn(item, action)}
              onViewPayment={(r) =>
                setSelectedPRForPayment(r.originalData || r)
              }
              onGoToTab={setReturnsSubTab}
            />
          </div>
        );
      case RETURNS_SUB_TABS.DAMAGED:
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <InventoryControlPanel
              activeTab={activeTab}
              search={search}
              setSearch={setSearch}
              filters={filters}
              setFilters={setFilters}
              dynamicSettings={dynamicSettings}
              categories={activeReturnFilterOptions?.categories}
              parties={activeReturnFilterOptions?.parties}
              partyLabel="Parties"
              showStatusFilter={false}
              onExport={handleExportDamagedItems}
              isExporting={isExporting}
            />
            <div className="flex items-center justify-between mb-4 px-2">
              <h2 className="text-[11px] font-black uppercase tracking-widest text-slate-500">
                Damaged Items
              </h2>
            </div>
            <DamagedItemsTable
              damagedItems={damagedItems}
              onView={(r) => {
                setSelDamagedItem(r);
              }}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      <InventoryStats
        activeTab={activeTab}
        viewMode="returns"
        subTab={returnsSubTab}
        isExpanded={false}
        setIsExpanded={() => {}}
        inventory={[]}
        sales={[]}
        returns={consolidatedReturns}
        damagedItems={damagedItems}
        requests={[]}
        purchaseReturns={consolidatedReturns.filter(
          (r) => r.rawType === "purchase" || r.returnType === "Purchase",
        )}
      />

      <Tabs
        tabs={[
          { id: RETURNS_SUB_TABS.MASTER, label: "Returns Master" },
          { id: RETURNS_SUB_TABS.PURCHASES, label: "Purchase Returns" },
          { id: RETURNS_SUB_TABS.SALES, label: "Sale Returns" },
          // { id: RETURNS_SUB_TABS.SITE, label: "Site Returns" },
          { id: RETURNS_SUB_TABS.DAMAGED, label: "Damaged Items" },
        ]}
        activeTab={returnsSubTab}
        onChange={(id) => {
          setReturnsSubTab(id);
          setSearch("");
        }}
        variant="sub"
        className="mb-2"
      />
      {renderReturnsContent()}

      <DamagedItemDetailModal
        damagedItem={selDamagedItem}
        onClose={() => setSelDamagedItem(null)}
      />
    </div>
  );
};

